import { useMemo } from 'react';

const useParseInt = (value: string, defaultValue?: number) =>
  useMemo(() => {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? defaultValue : parsed;
  }, [defaultValue, value]);

export default useParseInt;
